export default class Customer {
    /**
     * @param  {Object} cust
     * 由于两种对象命名不一样
     * 1.e税云购方管理对象
     * 2.从发票对象中抽取的购方对象
     */
    constructor() {
        const customer = {
            custBank: '', // 购方开户银行 ,
            custBankAccount: '', // 购方银行账号 ,
            custCode: '', // 购方编码 ,
            custCreditCode: '', // 购方纳税人信用代码 ,
            custEmail: '', // 购方邮箱 ,
            custAddress: '', // 购方地址
            custMobile: '', // 购方手机 ,
            custName: '', // 购方名称 ,
            custPhone: '', // 购方电话 ,
            creditType: '1', // 购方企业类型
            tax4CustBank: '', // 购方开户银行 ,
            tax4CustBankAccount: '', // 购方银行账号 ,
            tax4CustAddress: '', // 购方地址
            tax4CustPhone: '', // 购方电话 ,
        }
        Object.assign(this, customer)
    }

    fromCustomer(cust) {
        const customer = {
            custBank: cust.bank || '', // 购方开户银行 ,
            // custBankAccount: cust.bankAccount || '', // 购方银行账号 ,
            custCode: cust.customerCode || '', // 购方编码 ,
            custCreditCode: cust.creditCode || '', // 购方纳税人信用代码 ,
            custEmail: cust.email || '', // 购方邮箱 ,
            custAddress: cust.businessAddress || cust.registerAddress || '', // 购方地址
            // custMobile: cust.mobile || '', // 购方手机 ,
            custName: cust.customerName || '', // 购方名称 ,
            custPhone: cust.phone || '', // 购方电话 ,
            creditType: cust.taxplayerType || '1', // 购方企业类型
            custMobile: cust.mobile,
            tax4CustBank: cust.custBank || '', // 购方开户银行 ,
            tax4CustBankAccount: cust.custAccount ||'', // 购方银行账号 ,
            tax4CustAddress: cust.custAddress || cust.registerAddress || '', // 购方地址
            tax4CustPhone: cust.custPhone || cust.registerPhone || '', // 购方电话 ,
        }
        // if(customer.creditType!=='1' && customer.creditType!=='3') {
        //     customer.creditType = '1'
        // }
        Object.assign(this, customer)
        return this
    }

    fromInvoice(invoice) {
        const customer = {
            custBank: invoice.custBank,
            // custBankAccount: invoice.custBankAccount,
            custCode: invoice.custCode,
            custCreditCode: invoice.custCreditCode,
            custEmail: invoice.custEmail,
            custAddress: invoice.custAddress,
            custMobile: invoice.custMobile,
            custName: invoice.custName,
            // custPhone: invoice.custPhone,
            creditType: invoice.creditType, // 购方企业类型
            custPhone: invoice.custPhone || '',
            custBankAccount: invoice.custBankAccount || '',
            tax4CustBank: invoice.custBank || '', // 购方开户银行 ,
            tax4CustBankAccount: invoice.custAccount ||'', // 购方银行账号 ,
            tax4CustAddress: invoice.custAddress || '', // 购方地址
            tax4CustPhone: invoice.custPhone || '', // 购方电话 ,
        }
        Object.assign(this, customer)
        return this
    }
}




// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/standModel/Customer.js